import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Star, Quote } from 'lucide-react';

const Testimonials = () => {
  const { t } = useLanguage();

  const testimonials = [
    {
      name: 'Sophie Martin',
      role: t('testimonials.items.sophie.role'),
      image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=200&q=80',
      text: t('testimonials.items.sophie.text'),
      rating: 5
    },
    {
      name: 'Thomas Dubois',
      role: t('testimonials.items.thomas.role'),
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=200&q=80',
      text: t('testimonials.items.thomas.text'),
      rating: 5
    },
    {
      name: 'Marie Chen',
      role: t('testimonials.items.marie.role'),
      image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=200&q=80',
      text: t('testimonials.items.marie.text'),
      rating: 5
    }
  ];

  return (
    <section className="section-padding bg-[#F5F3EF]" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="overline mb-4">{t('testimonials.overline')}</p>
          <h2 className="font-playfair text-3xl sm:text-4xl lg:text-5xl text-[#1A1A2E] font-semibold">
            {t('testimonials.title')}
          </h2>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((item, index) => (
            <div
              key={index}
              className="card-light rounded-2xl p-6 transition-all"
              data-testid={`testimonial-${index}`}
            >
              {/* Quote Icon */}
              <Quote className="w-8 h-8 text-[#C9A227]/30 mb-4" />

              {/* Text */}
              <p className="text-[#4A4A5A] leading-relaxed mb-6">
                "{item.text}"
              </p>

              {/* Rating */}
              <div className="flex items-center gap-1 mb-4">
                {[...Array(item.rating)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 text-[#C9A227] fill-current" />
                ))}
              </div>

              {/* Author */}
              <div className="flex items-center gap-3 pt-4 border-t border-[#F5F3EF]">
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-12 h-12 rounded-full object-cover"
                />
                <div>
                  <p className="text-[#1A1A2E] font-medium">{item.name}</p>
                  <p className="text-[#8A8A9A] text-sm">{item.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
